// 自定义指令 ：失焦后 去除前后空格
const getInput = (el) => {
    let inputEle
    if (el.tagName !== 'INPUT') {
        if(el.querySelector('input')){
            inputEle = el.querySelector('input')
        }else if(el.querySelector('textarea')){
            inputEle = el.querySelector('textarea')
        }
    } else {
        inputEle = el
    }
    return inputEle
}
const dispatchEvent = (el, type) => {
    const evt = document.createEvent('HTMLEvents')
    evt.initEvent(type, true, true)
    el.dispatchEvent(evt)
}


export default (app) => {
    // 过滤前后空格的指令 v-trim
    app.directive('trim', {
        mounted(el) {
            const inputEle = getInput(el)
            const handler = (event) => {
                const newVal = event.target.value.trim()
                if (event.target.value !== newVal) {
                    event.target.value = newVal
                    dispatchEvent(inputEle, 'input')
                }
            }
            el.inputEle = inputEle
            el._blurHandler = handler
            inputEle.addEventListener('blur', handler)
        },
        unmounted(el) {
            const { inputEle } = el
            inputEle.removeEventListener('blur', el._blurHandler)
        }
    })
    // 获取焦点选中文字的指令 v-selectVal
    app.directive('selectVal', {
        mounted(el) {
            const inputEle = getInput(el)
            const handler = (event) => {
                event.srcElement.select();
            }
            el.inputEle = inputEle
            el._blurHandler = handler
            inputEle.addEventListener('focus', handler)
        },
        unmounted(el) {
            const { inputEle } = el
            inputEle.removeEventListener('focus', el._blurHandler)
        }
    })
}
